import { Component, OnInit, Inject } from "@angular/core";
import { Constant, UserRoleEnum, AddendumStatusEnum } from "../core/constant";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { Router } from "@angular/router";
import { Addendum } from "../models/addendum";
import { AddendumList } from "../models/addendum-list";
import { AddendumStatus } from "../models/addendumStatus";
import { Country } from "../models/country";
import { AddendumService } from "../services/addendum.service";
import { Observable } from "rxjs";
import { CryptographyService } from "../services/cryptography.service";
import { StandardService } from "../services/standard.service";
import { CustomEventNRService } from "../services/custom-event-nr.service";
import * as XLSX from "xlsx";


declare var $: any;
@Component({
  selector: "app-equipment-addendum-list",
  templateUrl: "./equipment-addendum-list.component.html",
  styleUrls: ["./equipment-addendum-list.component.scss"],
})
export class EquipmentAddendumListComponent implements OnInit {
    private exportTimeout: any;
  exportFilterList: any;
  exportCountrySelectedIds: any;
  equipmentException:boolean = true
  selectedRowsForExport: number[] = [];
  totalPages: any;
  searchKey: string = "";
  filteredAddendums: Addendum[] = [];
  userRole: number = 2; // 1 -> Global Admin , 2 -> Market Admin
  page: number = 1;
  pageSize: number = 10;
  collectionSize: number = 0;
  pageSizes: any[] = Constant.PageSizes;

  addendums: Addendum[] = [];
  countries: Country[] = [];
  addendumStatuses: AddendumStatus[] = [];
  error: string = "";
  countryId: Array<number> = [];
  loading: boolean = false;
  filterList: number[] = [];
  get userRoleEnum() {
    return UserRoleEnum;
  }

  constructor(
    private addendumService: AddendumService,
    private cryptographyService: CryptographyService,
    private router: Router,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private standardService: StandardService,
    private customEventNRService: CustomEventNRService,
  ) {}

  ngOnInit() {
    this.filterList = this.standardService.equipmentAddendumFiltration.filter;
    this.pageSize = this.standardService.equipmentAddendumFiltration.pageSize;
    this.page =
      this.standardService.equipmentAddendumFiltration.startingIndex || 1;
    this.userRole = this.getEffectiveUserRole();
    this.countryId = this.getCountryIdsForApi();
    this.getAddendums();

    $(window).scroll(function (event) {
      let st = $(this).scrollTop();
      if (st > 199) {
        $(".filter-panel-row").addClass("freeze");
      } else {
        $(".filter-panel-row").removeClass("freeze");
        $(".filter-panel-row").removeClass("freeze");
      }
    });
  }

  getEffectiveUserRole(): number {
    if (sessionStorage.getItem("userRoleId")) {
      return this.cryptographyService.decryptData(
        sessionStorage.getItem("userRoleId"),
      );
    }
    return this.cryptographyService.decryptData(this.storage.get("userRole"));
  }

  getEffectiveCountryIds(): number[] {
    const sessionCountryId = sessionStorage.getItem("selectedCountryID");
    if (sessionCountryId) {
      return [Number(JSON.parse(sessionCountryId))];
    }

    const stored = this.cryptographyService.decryptData(
      this.storage.get("countryId"),
    );
    return Array.isArray(stored) ? stored : [stored];
  }

  getCountryIdsForApi(): number[] {
    if (this.getEffectiveUserRole() === UserRoleEnum.MarketAdmin) {
      return this.getEffectiveCountryIds();
    }

    const storedCountryId =
      this.standardService.equipmentAddendumFiltration.countryId;
    if (storedCountryId?.length && !storedCountryId.includes(0)) {
      return [...storedCountryId];
    }

    return [0];
  }

  // getAllAddendumStatuses(): void {
  //   this.addendumService.getAllAddendumStatuses(this.userRole)
  //     .subscribe(
  //       (data: AddendumStatus[]) => {
  //         this.addendumStatuses = data;
  //       });
  // }
  /**
   * Selected Items Per Page Change
   * @return void
   */
  selectedItemsPerPageChange(event) {
    this.page = 1;
    this.pageSize = event.value;
    this.standardService.equipmentAddendumFiltration.pageSize = event.value;
    this.getAddendums();
  }

  /**
   * Get Addendums
   * @return void
   */
  getAddendums(): void {
    this.loading = true;
    this.standardService.equipmentAddendumFiltration.startingIndex = this.page;
    let isRemoveDraftBeforeRequest =
      this.getEffectiveUserRole() == UserRoleEnum.GlobalAdmin ? true : false;

    this.addendumService
      .getAllAddendumsByCountryId(
        this.countryId,
        isRemoveDraftBeforeRequest,
        (this.page - 1) * this.pageSize,
        this.pageSize,
        this.filterList,
        this.getEffectiveUserRole(),
        true,
      )
      .subscribe((data: AddendumList) => {
        this.addendums = data.addendums.map((obj: any) => {
          let c = [obj.countryId];
          let d = [obj.country];
          obj.countryId = c;
          obj.country = d;
          return new Addendum(obj, this.getEffectiveUserRole());
        });
       
        this.collectionSize = data.count;
        this.totalPages = Math.ceil(this.collectionSize / this.pageSize);
        

        this.applyFilters();
        if (this.filterList.length > 0) {
          this.customEventNRService.sendFilterEvent(
            "Grsallfilters",
            JSON.stringify(this.filterList),
            this.addendums.length,
          );
        }
        this.loading = false;
        (error) => {
          this.error = error;
          this.loading = false;
        };
      });
  }

  /**
   * Row selected
   * @return void
   */
  rowSelected(addendum: Addendum): void {
    console.log("select addendu",addendum)
    if (addendum.addendumStatus.id == AddendumStatusEnum.DraftBeforeRequest) {
      this.router.navigate(["/add-addendum/" + addendum.standard.id]);
    } else {
      this.router.navigate(["/addendum/" + addendum.id]);
    }
  }

  /**
   * Get All Countries
   * @return void
   */
  // getAllCountries(): Observable<void> {
  //   this.loading = true;
  //   return new Observable<void>(observer => {
  //     this.addendumService.getAllCountries()
  //       .subscribe(
  //         (data: Country[]) => {
  //           this.countries = data.map(obj => new Country(obj));
  //           this.loading = false;
  //           observer.next();
  //         });
  //   })
  // };

  selectCountry(countryIds: number[]) {
    this.page = 1;
    this.countryId = countryIds?.length ? [...countryIds] : [0];
    this.standardService.equipmentAddendumFiltration.countryId = this.countryId;
    this.getAddendums();
  }

  onSearchFromChild(searchValue: string) {
    this.searchKey = searchValue;
    this.page = 1;
    this.standardService.equipmentAddendumFiltration.startingIndex = this.page;
    this.applyFilters();
  }

  applyFilters(): void {
    let filtered = [...this.addendums];
    console.log("filtered",filtered)
    console.log("test addendum", filtered[0]);

    if (this.searchKey && this.searchKey.trim() !== "") {
      const searchTerm = this.searchKey.toLowerCase().trim();
      filtered = filtered.filter((addendum) => {
        const title = addendum.standard?.title;

        return title.toLowerCase().includes(searchTerm);
      });
    }

    this.filteredAddendums = filtered;
    // this.collectionSize = filtered.length;

    // Apply pagination
    // const startIndex = (this.page - 1) * this.pageSize;
    // const endIndex = startIndex + this.pageSize;
    // this.addendums = filtered.slice(startIndex, endIndex);
  }

  selectedStatuses(event) {
    this.page = 1;
    this.filterList = event;
    this.getAddendums();
  }

  onCountryfromChild(countryIds: number[]) {
    if (this.getEffectiveUserRole() === UserRoleEnum.MarketAdmin) {
      return;
    }
    this.selectCountry(countryIds);
  }

   backtoMainList(){
    if(this.searchKey){
      this.searchKey = ''
      this.getAddendums()
    }
  }

  goToNextPage() {
    if (this.page < this.totalPages) {
      this.page++;
      this.getAddendums();
    }
  }

  goToPreviousPage() {
    if (this.page > 1) {
      this.page--;
      this.getAddendums();
    }
  }

  onCheckboxChange(event: any, id: number) {
    if (event.checked) {
      if (!this.selectedRowsForExport.includes(id)) {
        this.selectedRowsForExport.push(id);
        console.log("Added:", id);
      }
    } else {
      const index = this.selectedRowsForExport.indexOf(id);
      if (index > -1) {
        this.selectedRowsForExport.splice(index, 1);
      }
    }
  }
 isSelected(id: number): boolean {
    return this.selectedRowsForExport && this.selectedRowsForExport.includes(id);
  }

  getSelectableRowsOnPage(): Addendum[] {
    return this.filteredAddendums || [];
  }

  isAllOnPageSelected(): boolean {
    const rows = this.getSelectableRowsOnPage();
    if (rows.length === 0) return false;
    return rows.every((r) => this.isSelected(r.id));
  }

  isSomeOnPageSelected(): boolean {
    const rows = this.getSelectableRowsOnPage();
    if (rows.length === 0) return false;
    const numSelected = rows.filter((r) => this.isSelected(r.id)).length;
    return numSelected > 0 && numSelected < rows.length;
  }

  selectAllOnPageChange(event: any): void {
    const rows = this.getSelectableRowsOnPage();
    if (event.checked) {
      rows.forEach((r) => {
        if (!this.isSelected(r.id)) {
          this.selectedRowsForExport.push(r.id);
        }
      });
    } else {
      const pageIds = new Set(rows.map((r) => r.id));
      this.selectedRowsForExport = this.selectedRowsForExport.filter(
        (id) => !pageIds.has(id),
      );
    }
  }


  getStatusStyle(statusName: string): any {
  const styles: { [key: string]: any } = {
    'Draft': { 'background-color': '#FFEBB780', 'color': '#BF8D0B' },
    'New': { 'background-color': '#D9DCF0B2', 'color': '#3F51B5' },
    'Approved': { 'background-color': '#CCECDF', 'color': '#00A15E' },
    'Rejected': { 'background-color': '#FCE6E6', 'color': '#E35B5B' },
    'Expired': { 'background-color': '#DDE1E680', 'color': '#696F77CC' },
    
  };
  return styles[statusName] || { 'background-color': '#fafafa', 'color': '#616161' };
}

getStatusIcon(statusName: string): string {
  const iconMap: { [key: string]: string } = {
   'Draft': '/assets/images/statusDraft',
    'New': '/assets/images/statusNew.svg',
    'Approved':  '/assets/images/statusApproved.svg',
    'Rejected':  '/assets/images/statusRejected.svg',
    'Expired':  '/assets/images/statusExpired.svg'
  };
  return iconMap[statusName] || 'assets/images/status-default.png';
}

setEquipmentExceptionCheck() {
    return this.equipmentException= true
  }

  tabClick(event:any){
    // Switching tabs should always land on a clean, unfiltered list rather than
    // carrying over whatever status/country filter was applied here before.
    this.standardService.addendumFiltration.filter = [];
    this.standardService.addendumFiltration.countryId = null;
    this.standardService.addendumFiltration.startingIndex = 1;
    this.router.navigate(['/addendum-list'])
  }
 

  
    handleExport(exportFilterList: any) {
      this.exportFilterList = exportFilterList;
      this.areBothFiltersReady();
    }
  
    handleCountryList(event: any) {
      this.exportCountrySelectedIds = event;
      this.areBothFiltersReady();
    }
  
    areBothFiltersReady() {
      if (this.exportTimeout) {
        clearTimeout(this.exportTimeout);
      }
      const hasFilters =
        this.exportFilterList &&
        this.exportFilterList.length > 0 &&
        this.exportFilterList[0]?.ids?.length > 0;
      const hasCountries =
        this.exportCountrySelectedIds && this.exportCountrySelectedIds.length > 0;
  
      if (hasFilters || hasCountries) {
        this.exportTimeout = setTimeout(() => {
          this.exportToExcel();
        }, 300);
      }else{
       this.exportTimeout = setTimeout(() => {
          this.exportToExcel();
        }, 300);
      }
    }
  
    exportToExcel(): void {
      let dataToExport = this.addendums;
      console.log("datatoExport", dataToExport)
      if (this.selectedRowsForExport?.length > 0) {
        dataToExport = this.addendums.filter((item) =>
          this.selectedRowsForExport.some((selected) => selected === item.id),
        );
      }
  
      if (this.exportFilterList?.[0]?.ids?.length > 0) {
        dataToExport = dataToExport.filter((item) =>
          this.exportFilterList[0].ids.some(
            (filter) => filter === item.addendumStatus.id,
          ),
        );
      }
  
      if (this.exportCountrySelectedIds?.length > 0) {
        console.log("Exporting country filter applied:", dataToExport);
        dataToExport = dataToExport.filter((item) =>
          this.exportCountrySelectedIds.some(
            (country) => country == item?.country[0]?.id,
          ),
        );
      }
  
      if (dataToExport.length === 0) {
        alert("No data to export!");
        return;
      }
  
       const formattedData = dataToExport.map(item => ({
      'Standard Title': item.standard?.title || 'N/A',
      'Description': item.description || 'N/A',
      'Country': item.country?.[0]?.name || 'N/A',
      'Approved/Rejected On': item.approvedOrRejectedDate 
        ? item.approvedOrRejectedDate 
        : '--',
      'Expiring On': item.expiryDate 
        ? item.expiryDate
        : '--',
      'Status': item.addendumStatus?.name || 'N/A'
    }));
  
      const timestamp = new Date()
        .toISOString()
        .slice(0, 19)
        .replace(/[:.]/g, "-");
      const fileName = `Export_Exceptions_${timestamp}.xlsx`;
  
      // Download Excel
      this.downloadExcel(formattedData, fileName);
    }
  
    downloadExcel(data: any[], fileName: string) {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Standards");
      this.standardService.saveXlsxWorkbook(workbook, fileName);
    }
}
